import { useQuery, useQueryClient } from 'react-query';
import { apiHttpService } from '../../../api/apiHttpService';
import { useEventFeed } from '../../../api/useEventFeed';

export default function useAskForEventUpdates(
  eventId: string | null | undefined,
) {
  const { data: activeEvent, refetch: refetchEvent } = useEventFeed({
    eventId,
  });

  const queryClient = useQueryClient();

  const timeStampUrl = activeEvent?.timeStampUrl;
  return useQuery<string | undefined | null>(
    ['eventFeedUpdates', timeStampUrl],
    async () => {
      // handling case when event comes but it's empty and doesn't have timeStampUrl
      if (!timeStampUrl) {
        refetchEvent();
        return null;
      }

      const { data: freshTimestamp } = await apiHttpService.get<string>(
        timeStampUrl + `?t=${Date.now()}`, // adding timestamp here to avoid cache of this request
      );

      const currentTimestamp = queryClient.getQueryData<string>([
        'eventFeedUpdates',
        timeStampUrl,
      ]);

      if (currentTimestamp && currentTimestamp !== freshTimestamp) {
        refetchEvent();
      }

      return freshTimestamp;
    },
    {
      refetchInterval: 10000, // ask for updates every 10 secs
      enabled: Boolean(activeEvent),
    },
  );
}
